module.exports = __webpack_public_path__ + "static/media/emphasis.f05f5765.png";